import { combineReducers } from '@reduxjs/toolkit';
import datakeys from './datakeys';
import pagination from './pagination';
import sort from './sort';
import totalElements from './totalElements';

const root = combineReducers({ totalElements, sort, datakeys, pagination });

export default root;
